import { TrustpilotLogo } from '../trustpilot-logo'

import styles from './styles.module.css'

export const HighlightReview = ({ highlightReview: { title, review, starsImage, user }, trustpilotUrl }) => {
  return (
    <a target='_blank' href={trustpilotUrl} className={styles.highlightReviewContainer} rel='noreferrer'>
      <div className={styles.mb16}>
        <TrustpilotLogo height='26' />
      </div>
      <h3 className={`${styles.title} ${styles.mb16}`}>{title}</h3>
      <div className={`${styles.flex} ${styles.mb16}`}>
        <img className={styles.starsImage} src={starsImage} alt='Trustpilot user review score' />
        <p className={styles.text}>By {user}</p>
      </div>
      <p className={styles.text}>"{review}"</p>
    </a>
  )
}
